import DistributionRegionFilter from '@/components/DistributionRegionFilter';
import { loadDistributionRegions } from '@/utils/distributionRegionLoader';
import { regionLabel } from '@/utils/distributionRegion';
export default {
  components: {
    DistributionRegionFilter: DistributionRegionFilter
  },
  data: function data() {
    return {
      distributionRegions: {
        names: {}
      }
    };
  },
  created: function created() {
    var _this = this;
    loadDistributionRegions().then(function (data) {
      _this.distributionRegions = data;
    }).catch(function () {});
  },
  methods: {
    distributionRegionLabel: function distributionRegionLabel(code, fallback) {
      return regionLabel(this.distributionRegions, code, fallback);
    }
  }
};